import * as React from 'react';
import Empty from '@app/react-common/Empty';

import { RecipientType, Column } from './types';

interface OfferRecipientsTableProps {
  emptyText?: string;
  columns: Column<RecipientType>[];
  data: RecipientType[];
}

const MIN_HEIGHT = 200;

const OfferRecipientsTable = (props: OfferRecipientsTableProps) => {
  const { columns, data, emptyText } = props;

  return data.length ? (
    <table className="table table-striped table-bordered">
      <thead>
        <tr>
          {columns.map(({ id, label, style }) => (
            <th key={id} style={style}>
              {label}
            </th>
          ))}
        </tr>
      </thead>
      <tbody>
        {data.map(agent => (
          <tr key={agent.email}>
            {columns.map(({ renderer }) => renderer(agent))}
          </tr>
        ))}
      </tbody>
    </table>
  ) : (
    <Empty height={MIN_HEIGHT} text={emptyText} />
  );
};

export default OfferRecipientsTable;
